export default {
    READ_ONLY_MODE: "Режим просмотра"
};
